var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___ek5udj",
  "V8": "GuildFolderItem.module__relative___ek5udj",
  "o6": "GuildFolderItem.module__collapsedFolder___ek5udj",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___ek5udj",
  "sD": "GuildFolderItem.module__miniGuildIcon___ek5udj",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___ek5udj",
  "mw": "GuildFolderItem.module__folderBadge___ek5udj",
  "M8": "GuildFolderItem.module__folderBadgeActive___ek5udj",
  "k9": "GuildFolderItem.module__expandedFolderBackground___ek5udj",
  "MJ": "GuildFolderItem.module__folderHeader___ek5udj",
  "mK": "GuildFolderItem.module__folderHeaderButton___ek5udj",
  "Eh": "GuildFolderItem.module__folderIcon___ek5udj",
  "QD": "GuildFolderItem.module__expandedGuilds___ek5udj",
  "h5": "GuildFolderItem.module__folderTooltipContainer___ek5udj",
  "bO": "GuildFolderItem.module__folderTooltipName___ek5udj",
  "Il": "GuildFolderItem.module__dropIndicatorTop___ek5udj",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___ek5udj",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___ek5udj",
};

module.exports = exports;
